import { CircularProgressProps } from './types';
import styles from './CircularProgress.module.scss';

export const CircularProgress = ({ progress }: CircularProgressProps) => {
	const circleProgressBarLength = 722.2;

	return (
		<div className={styles.circularProgress}>
			<svg viewBox="0 0 250 250">
				<circle className="bg" cx="125" cy="125" r="115" fill="none" strokeWidth="20"></circle>
				<circle
					className="fg"
					cx="125"
					cy="125"
					r="115"
					fill="none"
					strokeWidth="20"
					strokeDasharray={circleProgressBarLength}
					strokeDashoffset={circleProgressBarLength * ((100 - progress) / 100)}
				></circle>
			</svg>
			<span>{progress.toFixed(0)}%</span>
		</div>
	);
};
